export default function FooterSection() {
  const currentYear = 2025;

  return (
    <footer className="bg-brand-50 border-t border-brand-100">
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6">
          <div className="flex flex-col sm:flex-row gap-8 text-sm">
            <div>
              <ul className="flex flex-col sm:flex-row gap-4 sm:gap-8">
                {[
                  ["運営会社", "https://denryoku-ranking.site/common/pdf/company.pdf"],
                  ["プライバシーポリシー", "https://denryoku-ranking.site/common/pdf/cookiepolicy.pdf"],
                ].map(([label, href]) => (
                  <li key={label}>
                    <a href={href} className="text-gray-500 hover:text-brand-700 cursor-pointer transition-colors whitespace-nowrap">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-100 mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-gray-400">
          <span>© {currentYear} オール電化ランキング All Rights Reserved.</span>
        </div>
      </div>
    </footer>
  );
}